module.exports = __webpack_public_path__ + "img/9.4ae3ad52.png";